import MuiBadge from '@mui/material/Badge';

import { styled } from 'helpers';

import { BadgeProps } from './types';

export const Badge = styled(MuiBadge, {
  shouldForwardProp: (prop) => prop !== 'response' && prop !== 'presence' && prop !== 'avatarSize',
})<BadgeProps>`
  & .MuiBadge-badge.MuiBadge-standard {
    padding: 0px;
    height: ${({ avatarSize }) => (avatarSize > 48 ? '32px' : avatarSize === 48 ? '24px' : '14px')};
    width: ${({ avatarSize }) => (avatarSize > 48 ? '32px' : avatarSize === 48 ? '24px' : '14px')};
    font-size: ${({ avatarSize }) => (avatarSize < 48 ? '8px' : '10px')};
  }
  &.Online .MuiBadge-badge.MuiBadge-standard,
  &.Offline .MuiBadge-badge.MuiBadge-standard,
  &.Busy .MuiBadge-badge.MuiBadge-standard,
  &.Away .MuiBadge-badge.MuiBadge-standard,
  &.DND .MuiBadge-badge.MuiBadge-standard,
  &.response-badge .MuiBadge-badge.MuiBadge-standard {
    height: ${({ avatarSize }) => (avatarSize < 48 ? '10px' : '16px')};
    width: ${({ avatarSize }) => (avatarSize < 48 ? '10px' : '16px')};
  }
  & .MuiBadge-badge {
    background-color: ${({ theme }) => theme.palette.blueGrey[100]};
    border-color: ${({ theme }) => theme.palette.common.white};
    border-radius: 50%;
    border-width: 2px;
    border-style: solid;
    box-sizing: content-box;
    color: ${({ theme }) => theme.palette.secondary.contrastText};
    font-size: ${({ theme }) => theme.typography.pxToRem(10)};
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    height: ${({ avatarSize }) => (avatarSize <= 48 ? '10px' : '16px')};
    margin: ${({ avatarSize }) => (avatarSize === 24 ? '-1px' : '0')};
    min-width: 0;
    width: ${({ avatarSize }) => (avatarSize <= 48 ? '10px' : '16px')};
    .checkCircleSolid,
    .clockSolid,
    .circlePhoneSolid,
    .circleVideoSolid,
    .dnd,
    .faCircleSolid,
    .offline {
      font-size: ${({ avatarSize }) => (avatarSize < 48 ? '10px' : '16px')};
    }
    ${({ response, theme }) => {
      const responseStyles: { [response: string]: string } = {
        maybe: `
          background-color: ${theme.palette.blueGrey['A600']};
          color: ${theme.palette.common.white};
        `,
        no: `
          background-color: ${theme.palette.pink[700]};
          color: ${theme.palette.common.white};
        `,
        yes: `
          background-color: ${theme.palette.teal['A300']};
          color: ${theme.palette.common.white};
        `,
      };
      return response ? responseStyles[response] : '';
    }}
    ${({ theme, presence }) => {
      const presenceStyles: { [presence: string]: string } = {
        away: `
          color: ${theme.palette.orange[400]};
          background-color: ${theme.palette.common.white};
        `,
        busy: `
          color: ${theme.palette.pink[700]};
          background-color: ${theme.palette.common.white};
        `,
        busyOnCall: `
          color: ${theme.palette.pink[700]};
          background-color: ${theme.palette.common.white};
        `,
        busyOnMeeting: `
          color: ${theme.palette.pink[700]};
          background-color: ${theme.palette.common.white};
        `,
        offline: `
          color: ${theme.palette.blueGrey.A400};
          background-color: ${theme.palette.common.white};
        `,
        online: `
          color: ${theme.palette.teal[700]};
          background-color: ${theme.palette.common.white};
        `,
        dnd: `
          color: ${theme.palette.pink[700]};
          background-color: ${theme.palette.common.white};
        `,
      };

      return presence ? presenceStyles[typeof presence === 'string' ? presence : presence.presenceKey] : '';
    }}
  }
`;

export default Badge;
